import { EmailShareButton, FacebookShareButton, LinkedinShareButton } from 'react-share';
import { faFacebook, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useRouter } from 'next/router';
import type { ReactElement } from 'react';

import { Icon } from '@/components/icon';
import { URLS } from '@/lib/constants';
import { useAnalytics } from '@/lib/analytics';

export type SocialShareProps = { title: string };

const SocialShare = ({ title }: SocialShareProps): ReactElement => {
  const { track } = useAnalytics();
  const { asPath } = useRouter();
  const currentUrl = `${URLS.RACT_WEBSITE}${asPath}`;
  const trackEvent = (network: string) => () =>
    track('Social Share Clicked', {
      context: 'Social Share',
      text: network,
      href: asPath,
    });

  return (
    <div className="social-links">
      <ul className="hover-icons">
        <li>
          <FacebookShareButton url={currentUrl} quote={title} onClick={trackEvent('Facebook')}>
            <FontAwesomeIcon icon={faFacebook} size="2x" />
          </FacebookShareButton>
        </li>
        <li>
          <LinkedinShareButton url={currentUrl} title={title} onClick={trackEvent('LinkedIn')}>
            <FontAwesomeIcon icon={faLinkedin} size="2x" />
          </LinkedinShareButton>
        </li>
        <li>
          <EmailShareButton url={currentUrl} subject={title} beforeOnClick={trackEvent('Email')}>
            <Icon name="envelope" />
          </EmailShareButton>
        </li>
      </ul>
    </div>
  );
};

export { SocialShare };
